import React from "react";
import { Countdown } from "../../../../BaseComponents/Statistic/AntStatistic";
import { Style } from "../../../../lib/style/style";

export const StyledInputNumber = Style("input", {
  width: "35px !important",
  height: "40px",
  border: "1px solid var(--gray-5)",
  borderRadius: "var(--br-2)",

  "&:hover": {
    borderColor: "#703db8",
    borderInlineEndWidth: "1px",
  },
  "&:focus": {
    borderColor: "#703db8",
    boxShadow: "0 0 0 2px rgba(62, 12, 112, 0.14);",
    outline: "0",
    borderInlineEndWidth: "1px",
  },
  variants: {
    state: {
      error: {
        borderColor: "var(--red-6)",
        "&:focus": {
          borderColor: "var(--red-6)",
          boxShadow: "0 0 0 2px rgba(255, 38, 5, 0.06)",
          outline: 0,
          borderInlineEndWidth: "1px",
          outLine: 0,
        },
      },
    },
  },
});

export const StyledCountdown = Style(React.memo(Countdown), {
  "&.ant-statistic": {
    display: "grid",
  },
  ".ant-statistic-title": {
    order: 2,
    margin: 0,
    fontSize: "var(--fs-14)",
    color: "var(--gray-7)",
  },

  ".ant-statistic-content": {
    fontSize: "var(--fs-14)",
    color: "var(--gray-7)",
  },

  variants: {
    layout: {
      l1: {
        "&.ant-statistic": {
          gridTemplateColumns: "20px 180px",
        },
      },
      l2: {
        "&.ant-statistic": {
          gridTemplateColumns: "auto auto",
          gap: "var(--space-4)",
        },
      },
    },
  },
});
